import { Skeleton, Stack } from '@mui/material';

export const RefundListSkeleton = () => {
  return (
    <Stack spacing={2}>
      <Skeleton variant="rounded" width="100%" height={150} />
      <Skeleton variant="rounded" width="100%" height={150} />
      <Skeleton variant="rounded" width="100%" height={150} />
    </Stack>
  );
};
